import { useEffect, useState } from "react";
import { Library, Lock } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg, fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const ImportCast = ({ ep, reload }) => {
  const [open, setOpen] = useState(false);
  const [lib, setLib] = useState([]);
  useEffect(() => {
    if (open) http.get("/cast-library", { params: { exclude_episode: ep.id } }).then((r) => setLib(r.data));
  }, [open, ep.id]);
  const take = async (c) => {
    try { await http.post(`/episodes/${ep.id}/characters/import`, { character_id: c.id }); toast.success(`${c.name} joined this episode's cast`); await reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <>
      <Button data-testid="import-cast-btn" variant="secondary" onClick={() => setOpen(true)} className="rounded-full"><Library className="w-4 h-4 mr-2" />Series cast</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#11141E] border-[#2A3245] max-w-2xl" data-testid="import-cast-dialog">
          <DialogHeader><DialogTitle className="font-display">Reuse a locked character</DialogTitle></DialogHeader>
          <p className="text-xs text-slate-400">Same photos and the same registered voice — so they look and sound identical across episodes. A character with the same name here is replaced.</p>
          <div className="grid sm:grid-cols-2 gap-3 max-h-[60vh] overflow-y-auto">
            {lib.length === 0 && <div className="text-sm text-slate-500" data-testid="cast-library-empty">No locked characters in other episodes yet.</div>}
            {lib.map((c) => (
              <div key={c.id} className="card-s p-3 flex gap-3 items-center" data-testid={`library-char-${c.id}`}>
                <img src={fileUrl(c.portrait_front)} alt={c.name} className="w-14 h-16 object-cover rounded" />
                <div className="flex-1 min-w-0">
                  <div className="font-display truncate">{c.name}</div>
                  <div className="text-[11px] text-slate-500 truncate">{c.episode_title} · {new Date(c.created_at).toLocaleDateString()}</div>
                  <div className="font-mono text-[10px] text-amber-400 flex items-center gap-1 mt-0.5"><Lock className="w-3 h-3" />{c.voice_locked ? "look + voice" : "look only"}</div>
                </div>
                <Button data-testid={`import-char-${c.id}`} size="sm" onClick={() => take(c)} className="rounded-full">Use</Button>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
